import styled from 'styled-components'

import { DropdownButton } from '@new/__ui/DropdownButton'

export const SendButton = styled(DropdownButton)`
  flex: none;
  margin-left: auto;
`
